import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";

// Create a styled Button component that leverages theme and props
export const StyledButton = styled(Button)(({ theme, variant, color }) => ({
  textTransform: "none",
  borderRadius: "5px",
  padding: "10px 20px",
  fontFamily: "Rigid Square",
  fontWeight: "bold",
  fontSize: "18px",
  lineHeight: "24px",
  textTransform: "uppercase",
  ...(variant === "text-link" && {
    border: `1px solid ${
      color === "primary"
        ? theme.palette.primary.main
        : (color === "error" ? theme.palette.error.main : theme.palette.secondary.main)
    }`,
    color:
      color === "primary"
        ? theme.palette.primary.main
        : (color === "error" ? theme.palette.error[400] : theme.palette.secondary.main),
    "&:hover": {
      backgroundColor:
        color === "primary"
          ? "rgba(25, 118, 210, 0.04)"
          : (color === "error" ? theme.palette.error[600] : "rgba(233, 30, 99, 0.04)"),
    },
    "&:disabled": {
      borderColor:
        color === "primary"
          ? theme.palette.primary.light
          : (color === "error" ? theme.palette.error[200] : theme.palette.secondary.light),
      color: theme.palette.action.disabled,
    },
  }),
  ...(variant === "contained" && {
    backgroundColor:
      color === "primary"
        ? theme.palette.primary[800]
        : theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    "&:hover": {
      backgroundColor:
        color === "primary"
          ? theme.palette.primary[600]
          : theme.palette.secondary.dark,
    },
    "&:disabled": {
      backgroundColor:
        color === "primary"
          ? theme.palette.primary.light
          : theme.palette.secondary.light,
      color: theme.palette.action.disabled,
      border: `1px solid ${theme.palette.primary[500]}`,
    },
  }),
  ...(variant === "outlined" && {
    border: `1px solid ${
      color === "primary"
        ? theme.palette.primary.main
        : (color === "error" ? theme.palette.error.main : theme.palette.secondary.main)
    }`,
    color:
      color === "primary"
        ? theme.palette.primary.main
        : (color === "error" ? theme.palette.error[600] : theme.palette.secondary.main),
    "&:hover": {
      backgroundColor:
        color === "primary"
          ? theme.palette.primary[800]
          : (color === "error" ? theme.palette.error[600] : "rgba(233, 30, 99, 0.04)"),
      color:
        color === "primary"
          ? theme.palette.primary[300]
          : (color === "error" ? theme.palette.primary[100] : theme.palette.secondary.main),
    },
    "&:focus": {
      color:
        color === "primary"
          ? theme.palette.primary[400]
          : (color === "error" ? theme.palette.error[200] : theme.palette.secondary.main),
    },
    "&:disabled": {
      borderColor:
        color === "primary"
          ? theme.palette.primary.light
          : (color === "error" ? theme.palette.error[200] : theme.palette.secondary.light),
      color: theme.palette.action.disabled,
    },
  }
),
}));

export default StyledButton;
